import React from 'react'
import { getEntity, getFooterData, getHeaderData } from '@api/index'

import { default as normalizeBreadcrumb } from '@models/Breadcrumb'
import { default as normalizeFooterData } from '@models/Footer'
import { default as normalizeHeaderData } from '@models/Header'
import normalizeMetadata from '@models/Metadata'

import Breadcrumb from '@/molecules/Breadcrumb'
import { Banner, SectionBuilder } from '@/organisms'
import Layout from '@/organisms/Layout'
import normalizePostData from '@models/Post'
import { Col, Container, Row } from '@/atoms/Grid'
import dynamic from 'next/dynamic'
import PostContent from '@/organisms/PostContent'

const PostSidebar = dynamic(() => import('@/organisms/PostSidebar'), {
  ssr: true,
  loading: () => <p>Caricamento...</p>,
})

export const getServerSideProps = async ({ params }) => {
  try {
    const educationalData = await getEntity({ entity: 'educationalLife' })

    if (!educationalData || !educationalData.data) {
      return { notFound: true }
    }

    const policySection = educationalData.data.sections.find(
      (section) => section.__component === 'policy.policy'
    )

    if (!policySection || !policySection.policies) {
      return { notFound: true }
    }

    const policyData = policySection.policies.find(
      (policy) => policy.slug === params.slug
    )

    console.log({ policyData })

    if (!policyData) {
      return { notFound: true }
    }

    const [footer, header] = await Promise.all([
      getFooterData(),
      getHeaderData(),
    ])

    const metadata = normalizeMetadata(educationalData.data.seo) || {}
    const policyTitle = policyData.title || params.slug

    const breadcrumbItems = [
      { label: 'Di che ramo sei?', href: '/di-che-ramo-sei', role: 'link' },
      {
        label: 'Educational Vita',
        href: '/di-che-ramo-sei/educational-vita',
        role: 'link',
      },
      { label: policyTitle },
    ]

    console.log({ data: normalizePostData(policyData) })
    return {
      props: {
        metadata: metadata || {},
        breadcrumb: normalizeBreadcrumb(breadcrumbItems) || [],
        footer: normalizeFooterData(footer),
        header: normalizeHeaderData(header),
        content: normalizePostData(policyData),
      },
    }
  } catch (error) {
    console.error('Error in getServerSideProps:', error)
    return { notFound: true }
  }
}

const PolicyPage = ({ metadata, header, footer, breadcrumb, content }) => {
  return (
    <Layout
      metadata={metadata}
      headerData={header}
      footerData={footer}
      colorScheme='white'
    >
      <Breadcrumb items={breadcrumb} />
      <Banner {...content.banner} />
      <Container>
        <Row>
          <Col
            xs={12}
            lg={3}
            order={{ xs: 2, lg: 1 }}
          >
            <PostSidebar sections={content.sidebar} />
          </Col>
          <Col
            xs={12}
            lg={7}
            $offset={{ xs: 0, lg: 2 }}
            order={{ xs: 1, lg: 2 }}
          >
            <PostContent {...content.content} />
          </Col>
        </Row>
      </Container>
      <SectionBuilder data={content.sections} />
    </Layout>
  )
}

export default PolicyPage
